import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "card card-custom" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-label" }, " Finalize a sua inscrição! ")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = { class: "thanks-box shadow-lg border-lg-2 rounded m-auto mb-lg-12" }
const _hoisted_7 = { class: "p-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-center" }, "Quando o pagamento for aprovado, o seu acesso será liberado no Hacking Club.", -1)
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-column justify-content-center mb-4\"><div class=\"d-flex flex-column bg-blue-lightest rounded pix-instruction\"><div class=\"d-flex align-items-center justify-content-center py-4 px-3\"><span class=\"step-icon\"><svg width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" style=\"fill:var(--gray-500);\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z\" fill=\"#355CC0\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.1913 5.03806C10.3782 5.11545 10.5 5.29777 10.5 5.5V13H12.5C12.7761 13 13 13.2239 13 13.5C13 13.7761 12.7761 14 12.5 14H7.5C7.22386 14 7 13.7761 7 13.5C7 13.2239 7.22386 13 7.5 13H9.5V6.70711L8.35355 7.85355C8.15829 8.04881 7.84171 8.04881 7.64645 7.85355C7.45118 7.65829 7.45118 7.34171 7.64645 7.14645L9.64645 5.14645C9.78945 5.00345 10.0045 4.96067 10.1913 5.03806Z\" fill=\"#355CC0\"></path></svg></span><p class=\"ml-3 mb-0 text-1 text-gray-900\"> Abra o aplicativo do seu banco e acesse a área Pix </p></div></div><div class=\"d-flex flex-column bg-blue-lightest rounded pix-instruction\"><div class=\"d-flex align-items-center justify-content-center py-4 px-3\"><span class=\"step-icon\"><svg width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" style=\"fill:var(--gray-500);\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z\" fill=\"#355CC0\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.089 5.16779C12.179 5.51438 13 6.42191 13 7.49999C13 8.18108 12.6557 8.73529 12.2263 9.19907C11.8273 9.62996 11.3002 10.0394 10.7824 10.4416C10.7489 10.4676 10.7154 10.4937 10.682 10.5197C9.73797 11.2539 8.80834 12.0065 8.26305 13H12.5C12.7761 13 13 13.2239 13 13.5C13 13.7761 12.7761 14 12.5 14H7.5C7.33928 14 7.18835 13.9227 7.09438 13.7924C7.0004 13.662 6.97483 13.4944 7.02566 13.3419C7.58052 11.6773 8.9598 10.5923 10.068 9.73031C10.0926 9.71123 10.117 9.69227 10.1412 9.67343C10.6853 9.25042 11.1513 8.88819 11.4925 8.51966C11.8443 8.13969 12 7.8189 12 7.49999C12 6.96284 11.571 6.37038 10.786 6.12078C10.0279 5.87972 8.94922 5.98094 7.81235 6.89043C7.59672 7.06294 7.28207 7.02798 7.10957 6.81235C6.93706 6.59672 6.97202 6.28207 7.18765 6.10956C8.55078 5.01906 9.97211 4.81265 11.089 5.16779Z\" fill=\"#355CC0\"></path></svg></span><p class=\"ml-3 mb-0 text-1 text-gray-900\"> Selecione a opção pagar com código Pix Copia e Cola e cole o código no espaço indicado no aplicativo </p></div></div><div class=\"d-flex flex-column bg-blue-lightest rounded pix-instruction\"><div class=\"d-flex align-items-center justify-content-center py-4 px-3\"><span class=\"step-icon\"><svg width=\"21\" height=\"21\" viewBox=\"0 0 21 21\" style=\"fill:var(--gray-500);\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z\" fill=\"#355CC0\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.5 6.5L7.14645 6.14645C6.95118 6.34171 6.95118 6.65829 7.14645 6.85355C7.34163 7.04873 7.65802 7.04882 7.85331 6.8538L7.85222 6.85489M7.5 6.5C7.14645 6.14645 7.14645 6.14645 7.14645 6.14645L7.14767 6.14523L7.14927 6.14364L7.15361 6.13938L7.16677 6.1267C7.17752 6.11646 7.19222 6.10272 7.21075 6.08598C7.2478 6.05252 7.30032 6.00693 7.36734 5.95332C7.50108 5.84632 7.69437 5.70591 7.93943 5.56588C8.42746 5.287 9.13811 5 10 5C11.7011 5 13 6.15432 13 7.5C13 8.18503 12.6509 8.83365 11.9648 9.29103C11.8226 9.38588 11.6664 9.47233 11.4961 9.54968C11.6833 9.65276 11.8538 9.76897 12.0076 9.89714C12.691 10.4667 13 11.2359 13 12C13 13.4931 11.8081 15 10 15C9.19489 15 8.52315 14.8659 8.05014 14.7308C7.81335 14.6631 7.62531 14.5949 7.49399 14.5424C7.42829 14.5161 7.37667 14.4937 7.34011 14.4772C7.32182 14.4689 7.30729 14.4621 7.29663 14.457L7.28356 14.4508L7.27924 14.4486L7.27763 14.4478L7.27667 14.4474C7.27667 14.4474 7.27639 14.4472 7.5 14L7.27667 14.4474C7.02968 14.3239 6.92929 14.0234 7.05279 13.7764C7.17605 13.5299 7.47548 13.4297 7.7222 13.5521L7.72336 13.5527L7.72656 13.5542C7.73129 13.5564 7.7397 13.5604 7.75169 13.5658C7.77567 13.5766 7.81389 13.5933 7.86538 13.6139C7.96844 13.6551 8.12415 13.7119 8.32486 13.7692C8.72685 13.8841 9.30511 14 10 14C11.1919 14 12 13.0069 12 12C12 11.5141 11.809 11.0333 11.3674 10.6654C10.9199 10.2924 10.1705 10 9 10C8.72386 10 8.5 9.77614 8.5 9.5C8.5 9.22386 8.72386 9 9 9C10.1915 9 10.9579 8.76049 11.4101 8.45897C11.8491 8.16635 12 7.81497 12 7.5C12 6.84568 11.2989 6 10 6C9.36189 6 8.82254 6.213 8.43557 6.43412C8.24312 6.54409 8.09267 6.65368 7.99203 6.73418C7.94187 6.77432 7.90454 6.80685 7.88104 6.82808C7.8693 6.83869 7.86106 6.84643 7.85642 6.85084L7.85222 6.85489\" fill=\"#355CC0\"></path></svg></span><p class=\"ml-3 mb-0 text-1 text-gray-900\"> Após a confirmação do pagamento, você será redirecionado automaticamente. </p></div></div></div>", 1)
const _hoisted_11 = { class: "w-100 d-flex" }
const _hoisted_12 = { class: "qr-code d-flex justify-content-center w-100 mb-3 mt-0" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "d-flex flex-column justify-content-center w-50 mt-3" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "d-flex flex-column mt-4" }
const _hoisted_17 = {
  "data-v-e2b86b8c": "",
  class: "p-4 d-flex justify-content-between align-items-center bg-gray-100 border border-gray-200 rounded transaction-reference d-flex w-100 mt-4"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", {
  "data-v-e2b86b8c": "",
  class: "font-weight-bold text-1"
}, " Código da transação: ", -1)
const _hoisted_19 = {
  "data-v-e2b86b8c": "",
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_20 = {
  "data-v-e2b86b8c": "",
  id: "transactionReference",
  class: "text-2"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center items-align-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "p-4 d-flex justify-content-between align-items-center bg-gray-100 border border-gray-200 rounded transaction-reference d-flex w-20 mt-4" }, [
      /*#__PURE__*/_createElementVNode("span", {
        "data-v-e2b86b8c": "",
        class: "font-weight-bold text-1"
      }, " Status: "),
      /*#__PURE__*/_createElementVNode("div", {
        "data-v-e2b86b8c": "",
        class: "d-flex align-items-center justify-content-between"
      }, [
        /*#__PURE__*/_createElementVNode("span", {
          "data-v-e2b86b8c": "",
          id: "transactionReference",
          class: "text-2"
        }, [
          /*#__PURE__*/_createTextVNode("  Aguardando pagamento   "),
          /*#__PURE__*/_createElementVNode("div", {
            class: "spinner-grow spinner-grow-sm text-warning",
            role: "status"
          }, [
            /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1)
const _hoisted_22 = {
  key: 1,
  class: "card-body"
}
const _hoisted_23 = { class: "thanks-box shadow-lg border-lg-2 rounded m-auto mb-lg-12" }
const _hoisted_24 = { class: "p-5" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-center" }, "Quando o pagamento for aprovado, o seu acesso será liberado no Hacking Club.", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-gray-600 text-center" }, "O pagamento via boleto demora entre 2 à 3 dias úteis para ser compensado e seu acesso liberado no Hacking Club ", -1)
const _hoisted_27 = { class: "d-flex flex-column align-items-center" }
const _hoisted_28 = { class: "row w-100 h-600px" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "d-flex flex-column justify-content-center w-50 mt-3" }
const _hoisted_31 = { class: "d-flex flex-column" }
const _hoisted_32 = { class: "d-flex flex-column mt-4" }
const _hoisted_33 = {
  "data-v-e2b86b8c": "",
  class: "p-4 d-flex justify-content-between align-items-center bg-gray-100 border border-gray-200 rounded transaction-reference d-flex w-100 mt-4"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", {
  "data-v-e2b86b8c": "",
  class: "font-weight-bold text-1"
}, " Código da transação: ", -1)
const _hoisted_35 = {
  "data-v-e2b86b8c": "",
  class: "d-flex align-items-center justify-content-between"
}
const _hoisted_36 = {
  "data-v-e2b86b8c": "",
  id: "transactionReference",
  class: "text-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.transaction.payment_method == 'pix')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("img", {
                          src: _ctx.transaction.payment_url,
                          alt: "payment qr code",
                          class: "qr-codeimage"
                        }, null, 8, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyURL(_ctx.transaction.payment_code))),
                              type: "button",
                              class: "btn btn-secondary flex-1 m-0 py-1"
                            }, " Copiar código PIX ")
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.transaction.id), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_21
            ]))
          : _createCommentVNode("", true),
        (_ctx.transaction.payment_method == 'boleto')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("iframe", {
                        src: _ctx.transaction.payment_download_url,
                        frameborder: "0"
                      }, null, 8, _hoisted_29)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyURL(_ctx.transaction.payment_code))),
                            type: "button",
                            class: "btn btn-secondary flex-1 m-0 py-1"
                          }, " Copiar linha digitavel ")
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.transaction.id), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}